import { normalizePhoneNumber } from '@fastcampus/util/str';
const kakaoKeys = {
  jsKey: '47e80500742c575560c42dcbd3072c1c',
  publicId: '_xexoqxjl',
  uuid: '@fastcampus',
};
export class KakaoAuth {
  constructor() {
    this.scope = `profile, plusfriends, account_email, phone_number`;
    this.accessToken = '';
    this.kakaoId = '';
  }
  init() {
    window.Kakao.init(kakaoKeys.jsKey);
  }
  async login() {
    return new Promise((resolve) => {
      window.Kakao.Auth.login({
        scope: this.scope,
        success: async (auth) => {
          const merge = {
            ...(await this.userMe(auth)),
            ...(await this.serviceTerms()),
            ...(await this.getRelation()),
          };
          resolve(merge);
        },
        fail: (err) => {
          console.log('signin api err', err);
        },
      });
    });
  }
  async logout() {
    //자체 auth 사용 하므로 실제 사용될 경우 없음
    if (window.Kakao.Auth.getAccessToken()) {
      try {
        window.Kakao.Auth.logout((res) => {
          if (!res) return false;
          return true;
        });
      } catch (err) {
        return true;
      }
    } else {
      return true;
    }
  }
  async leave() {
    let leaveResult = {
      error: 0,
    };
    await this.login();
    const getStatus = await this.getStatus();
    if (getStatus === 'connected') {
      await this.unlinkUser();
    } else {
      leaveResult.error = 404;
      leaveResult.message = '카카오 로그인 상태에서만 탈퇴가 가능 합니다.';
    }
    return leaveResult;
  }
  async accessTokenInfo() {
    return new Promise((resolve) => {
      window.Kakao.API.request({
        url: '/v1/user/access_token_info',
        success: (res) => {
          resolve(res);
        },
        fail: (err) => {
          resolve(false);
        },
      });
    });
  }
  async userMe(auth) {
    return new Promise((resolve) => {
      window.Kakao.API.request({
        url: '/v2/user/me',
        success: (res) => {
          const kakaoAccount = res.kakao_account;
          const kakaoAccountInfo = {
            snsId: res.id.toString(), //Number 이지만 다른 소셜은 아이디가 문자열임
            nickName: kakaoAccount.profile.nickname,
            snsEmail: kakaoAccount.email,
            accessToken: auth.access_token,
            profileImage: kakaoAccount.profile.profile_image_url,
            phoneNumber: normalizePhoneNumber(kakaoAccount.phone_number),
            provider: 'KAKAO',
            hasEmail: kakaoAccount.has_email,
            isEmailValid: kakaoAccount.is_email_valid,
            isEmailVerified: kakaoAccount.is_email_verified,
            hasPhoneNumber: kakaoAccount.has_phone_number,
          };
          this.accessToken = kakaoAccountInfo.accessToken;
          this.kakaoId = kakaoAccountInfo.snsId;
          resolve(kakaoAccountInfo);
        },
        fail: (err) => {
          console.log('kakao user/me err', err);
        },
      });
    });
  }
  async serviceTerms() {
    return new Promise((resolve) => {
      window.Kakao.API.request({
        url: '/v1/user/service/terms',
        success: (res) => {
          //필수:[fc_kakaosync_terms,fc_kakaosync_privacy], 옵션[fc_kakaosync_agreement-marketing]
          const serviceTerms = {
            serviceAgreement: res.allowed_service_terms.some((it) => it.tag === 'fc_kakaosync_terms'),
            privacyAgreement: res.allowed_service_terms.some((it) => it.tag === 'fc_kakaosync_privacy'),
            marketingAgreement: res.allowed_service_terms.some((it) => it.tag === 'fc_kakaosync_agreement-marketing'),
          };
          resolve(serviceTerms);
        },
        fail: (err) => {
          console.log('kakao service/terms err', err);
        },
      });
    });
  }
  async getStatus() {
    return new Promise((resolve) => {
      try {
        window.Kakao.Auth.getStatusInfo((res) => {
          resolve(res.status);
        });
      } catch (err) {
        console.log('get status err', err);
      }
    });
  }
  async unlinkUser() {
    window.Kakao.API.request({
      url: '/v1/user/unlink',
      success: async () => {
        return true;
      },
      fail: () => {
        return false;
      },
    });
  }
  async getRelation() {
    return new Promise((resolve) => {
      window.Kakao.API.request({
        url: '/v1/api/talk/plusfriends',
        success: async (res) => {
          //relation : 친구 추가(ADDED), 관계 없음(NONE), 차단(BLOCKED)
          const plus_friend = {
            plusFriendRelation: res.plus_friends.filter((it) => it.plus_friend_uuid === kakaoKeys.uuid)[0].relation,
          };
          resolve(plus_friend);
        },
        fail: (err) => {
          resolve(false);
        },
      });
    });
  }
  addChannel() {
    window.Kakao.Channel.addChannel({
      channelPublicId: kakaoKeys.publicId,
    });
  }
  chatChannel() {
    window.Kakao.Channel.chat({
      channelPublicId: kakaoKeys.publicId,
    });
  }
}
